var _excluded = ["title", "upperTitle", "icon"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from 'react';
import { ActionButtonStyled, IconStyled as Icon, TitleStyled as Title, UpperTitleStyled as UpperTitle } from './styles/ActionButtonStyled';
;
var ActionButton = function ActionButton(_ref) {
  var title = _ref.title,
    upperTitle = _ref.upperTitle,
    icon = _ref.icon,
    props = _objectWithoutProperties(_ref, _excluded);
  return React.createElement(ActionButtonStyled, props, React.createElement(Icon, {
    as: icon
  }), React.createElement(UpperTitle, null, upperTitle), React.createElement(Title, null, title));
};
export default ActionButton;